export default __webpack_public_path__ + "static/media/flag.ebc4fdaf.svg";